// LocalStorage-backed tutorial tip meta helpers
// Replaces server persistence with client-only storage under key 'tutorialTips'

const STORAGE_KEY = 'tutorialTips';

function _readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) || {};
  } catch (e) {
    return {};
  }
}

function _writeAll(obj) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(obj || {}));
  } catch (e) {
    // ignore
  }
}

export async function getTutorialTipMeta(tipId) {
  const all = _readAll();
  return all[tipId] || {};
}

export async function setTutorialTipMeta(tipId, payload = {}) {
  try {
    const all = _readAll();
    const prev = all[tipId] || {};
    const next = { ...prev, ...payload, updatedAt: new Date().toISOString() };
    all[tipId] = next;
    _writeAll(all);
    return { ok: true, tipId, meta: next };
  } catch (e) {
    return { error: true };
  }
}
